/* unplugin-vue-components disabled */import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=c88a567a&lang=scss"

const __exports__ = script;

export default __exports__